import { render, staticRenderFns } from "./BorderArea.vue?vue&type=template&id=a3dd65ea&scoped=true&"
import script from "./BorderArea.vue?vue&type=script&lang=js&"
export * from "./BorderArea.vue?vue&type=script&lang=js&"
import style0 from "./BorderArea.vue?vue&type=style&index=0&id=a3dd65ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3dd65ea",
  null
  
)

export default component.exports